"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = _interopRequireDefault(require("../../../../utils/environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TAG_ID = 'fluffy-video-youtube-iframe-api';
var TAG_SRC = 'https://www.youtube.com/iframe_api';
var API_READY_RESOLVER = function API_READY_RESOLVER() {};
var API_READY = new Promise(function (resolve) {
  //@ts-ignore
  API_READY_RESOLVER = resolve;
});
var onYouTubeAPIReady = function onYouTubeAPIReady() {
  return new Promise(function (resolve) {
    if (_environment.default.isClient) {
      //@ts-ignore
      if (typeof window.onYouTubeIframeAPIReady !== 'function') {
        API_READY.then(function () {
          return resolve(true);
        });
        //@ts-ignore
        window.onYouTubeIframeAPIReady = function () {
          return API_READY_RESOLVER();
        };
      } else {
        API_READY.then(function () {
          return resolve(true);
        });
      }
    } else {
      resolve(true);
    }
  });
};
var initiate = function initiate() {
  var _a;
  if (_environment.default.isClient) {
    var youTubeApiScriptTag = document.getElementById(TAG_ID);
    if (!youTubeApiScriptTag) {
      var tag = document.createElement('script');
      tag.id = TAG_ID;
      tag.src = TAG_SRC;
      tag.async = true;
      tag.defer = true;
      var firstScriptTag = document.getElementsByTagName('script')[0];
      (_a = firstScriptTag === null || firstScriptTag === void 0 ? void 0 : firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(tag, firstScriptTag);
    }
  }
};
var getVideoId = function getVideoId(url) {
  var _a;
  if (url) {
    // eslint-disable-next-line no-useless-escape
    return (_a = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)) === null || _a === void 0 ? void 0 : _a[2];
  }
};
var getVideoSrc = function getVideoSrc(id) {
  if (id) {
    return "https://www.youtube.com/embed/".concat(id, "?&enablejsapi=1");
  } else {
    return null;
  }
};
var Youtube = {
  initiate: initiate,
  onReady: onYouTubeAPIReady,
  getVideoId: getVideoId,
  getVideoSrc: getVideoSrc
};
var _default = Youtube;
exports.default = _default;